export enum ContactType {
  PERSONAL = 'personal',
  COMPANY = 'company'
}
